import { useCallback } from 'react';
import { useAppSelector } from '../../stores/redux.store';

/**
 * Provides a standalone auxiliary check-username call outside the normal login context,
 * for example when checking whether an account exists. It does not dispatch login actions,
 * navigate, or interpret the response's login flow instructions.
 *
 * Returns an on-demand callback accepting a username. Callers own request timing and response
 * handling: HTTP errors resolve with the raw Response; network errors reject the promise.
 */
export const useFetchV2CheckUsername = () => {
  const csrfToken = useAppSelector(state => state.csrfToken);

  return useCallback(
    (username: string): Promise<Response> =>
      fetch('/rest/v2/check-username', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
        body: JSON.stringify({ username }),
      }),
    [csrfToken]
  );
};
